import { Doc, DocModel } from './Doc';
import { Subject, SubjectModel } from './Subject';
import { PrmService } from '../../gs-core/common/services';
import { Organization } from '../../gs-core/common/models';

export const hydrateSubjectOrgs = async (
  subject: Subject | undefined,
  prmService: PrmService
): Promise<Subject | undefined> => {
  if (subject) {
    const { user, type } = subject;
    const groups = await prmService.mergeAll(subject.groups) as Organization[];
    return SubjectModel.create({ user, type, groups });
  }
  return subject;
};

export const hydrateOwningUnitOrgs = async (
  owningUnit: Organization | undefined,
  prmService: PrmService
): Promise<Organization | undefined> => {
  return owningUnit && await prmService.merge(owningUnit);
};
export const hydrateOrgs = async (doc: Doc, prmService: PrmService): Promise<Doc> => {
  const owningUnit = await hydrateOwningUnitOrgs(doc.owningUnit, prmService);
  const subject = await hydrateSubjectOrgs(doc.subject, prmService);
  return DocModel.create({ ...doc, subject, owningUnit });
};

export const hydrateManyOrgs = async (docs: Doc[], prmService: PrmService): Promise<Doc[]> => {
  // Doing this sequential (not Promise.all) to prevent overlapping prm calls for the same units
  // When the cache is empty, 12 calls would go out for the same unit
  const hydratedDocs = [];

  for (const doc of docs) {
    const hydratedDoc = await hydrateOrgs(doc, prmService);
    hydratedDocs.push(hydratedDoc);
  }

  return hydratedDocs;
};

export const hydrateFull = async(doc: Doc, prmService: PrmService): Promise<Doc> => {
  let { subject, owningUnit } = doc;
  if (subject) {
    const user = await prmService.findUser(subject.user.id as number);
    subject = SubjectModel.create({ user, type: subject.type });
  }
  owningUnit = owningUnit && await prmService.findUser(owningUnit.id as number) as Organization;
  return DocModel.create({ ...doc, subject, owningUnit });
};



// WEBPACK FOOTER //
// ./src/common/models/DocHydrater.ts